import React, { useRef } from "react";
import { FiSmartphone } from "react-icons/fi";
import { MdLocationOn } from "react-icons/md";
import { AiOutlineMail } from "react-icons/ai";
import emailjs from "@emailjs/browser";
import { motion } from "framer-motion";
import { useState } from "react";
import animatedImage from "../../assets/gif/74694-confetti-unscreen.gif";
import useSound from "use-sound";
import mySound from "../../assets/sound/i-did-it-message-tone.mp3";
import { ToastContainer, toast } from "react-toastify";
import MapImage from "../../assets/map-light.png";
import "react-toastify/dist/ReactToastify.css";

const Contact = () => {
  const [showAnimation, setShowAnimation] = useState(false);
  const [notRobot, setNotRobot] = useState(false);
  const audio = new Audio("../../assets/sound/i-did-it-message-tone.mp3");
  const [playSound] = useSound(mySound);
  const notify = () => toast("SuccessFully send Email", {});

  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm(
        "service_x549vlf",
        "template_vzlso47",
        form.current,
        "7G7dbRbaC80_N0Nol"
      )
      .then(
        (result) => {
          setShowAnimation(true);
          e.target.reset();
          playSound();
          notify();
          setTimeout(() => {
            setShowAnimation(false);
          }, 4000);
        },
        (error) => {
          console.log(error.text);
        }
      );
  };

  return (
    <div id="contact" className="   py-32 overflow-hidden">
      <ToastContainer
        toastStyle={{
          backgroundColor: "#38D9A9",
          color: "#E2E8F0",
        }}
      />
      <div className="pt-32  MyContainer relative after:absolute after:content-['Contact']  after:tracking-widest after:text-own-gray-black after:text-[4rem]   sm:after:text-[7rem] after:opacity-50 after:left-[50%] after:-translate-x-[50%] after:top-[50px] after:-z-10">
        <div className="flex justify-between lg:flex-row flex-col gap-5">
          <div className="w-full">
            <form
              ref={form}
              onSubmit={sendEmail}
              action=""
              className="grid lg:grid-cols-2 grid-cols-1 "
            >
              <div
                style={{
                  backgroundImage: `url(${MapImage})`,
                  width: "100%",
                  height: "100%",
                  backgroundRepeat: "no-repeat",
                  backgroundSize: "cover",
                }}
                className="p-5 "
              >
                <div>
                  <div class="form-control">
                    <p className="text-center text-[20px] mb-5">Talk to me</p>
                    <div className="grid grid-cols-2 gap-4">
                      <div className="text-center bg-own-primary bg-opacity-20 border-2 border-own-border-color border-opacity-10 py-6">
                        <span>
                          <i className="ri-facebook-fill text-[24px] text-own-secondary"></i>
                        </span>
                        <h3 className="text-[18px] font-semibold">Facebook</h3>
                        <p className="text-[13px]">@sohagzayan360</p>
                        <a
                          href="https://www.facebook.com/sohagzayan360/"
                          target="_blank"
                          rel="noopener noreferrer"
                          className="flex items-center justify-center text-own-secondary font-semibold"
                        >
                          Send Message{" "}
                          <i className="ri-arrow-right-line text-[22px] ml-3 "></i>
                        </a>
                      </div>
                      <div className="text-center bg-own-primary bg-opacity-20 border-2 border-own-border-color border-opacity-10 py-6">
                        <span>
                          <i className="ri-linkedin-fill text-[24px] text-own-secondary"></i>
                        </span>
                        <h3 className="text-[18px] font-semibold">Linkedin</h3>
                        <p className="text-[13px]">@sohagzayan</p>
                        <a
                          href="https://www.linkedin.com/in/sohag-zayan/"
                          target="_blank"
                          rel="noopener noreferrer"
                          className="flex items-center justify-center text-own-secondary font-semibold"
                        >
                          Send Message{" "}
                          <i className="ri-arrow-right-line text-[22px] ml-3 "></i>
                        </a>
                      </div>
                      <div className="text-center bg-own-primary bg-opacity-20 border-2 border-own-border-color border-opacity-10 py-6">
                        <span>
                          <i className="ri-github-line text-[24px] text-own-secondary"></i>
                        </span>
                        <h3 className="text-[18px] font-semibold">Github</h3>
                        <p className="text-[13px]">@sohagzayan</p>
                        <a
                          href="https://github.com/sohagzayan"
                          target="_blank"
                          rel="noopener noreferrer"
                          className="flex items-center justify-center text-own-secondary font-semibold"
                        >
                          Send Message{" "}
                          <i className="ri-arrow-right-line text-[22px] ml-3 "></i>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="p-3 ">
                <p className="text-center text-[20px] mb-5">Send me on email</p>
                <input
                  data-aos="zoom-out"
                  name="from_name"
                  required
                  type="text"
                  placeholder="Name"
                  class=" placeholder:text-own-ternary py-2 outline-none  bg-own-primary px-3 rounded-sm border-b-[1px] border-t-[1px] border-own-border-color border-opacity-25 text-own-gray-white font-semibold w-full mb-4"
                />
                <input
                  data-aos="zoom-out"
                  required
                  name="user_email"
                  type="email"
                  placeholder="Email Address"
                  class="  placeholder:text-own-ternary py-2 outline-none border-b-[1px] border-t-[1px] border-own-border-color border-opacity-25   bg-own-primary px-3 rounded-sm  text-own-gray-white font-semibold w-full mb-4"
                />
                <textarea
                  name="message"
                  required
                  class=" w-[100%]  mb-4 border-b-[1px] border-t-[1px] border-own-border-color border-opacity-20 bg-own-primary h-[200px] p-3 rounded-sm font-medium outline-none text-own-gray-white  "
                  placeholder="Write your text here ... .. ."
                ></textarea>
                {showAnimation ? (
                  <div className="absolute top-[30%] right-[10%]">
                    <img src={animatedImage} alt="" />
                  </div>
                ) : null}
                <button
                  value="Send me message"
                  type="submit"
                  className={
                    notRobot
                      ? "btn-animated block w-full capitalize"
                      : "btn-animated block w-full  capitalize"
                  }
                >
                  Send Email
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;
